import React from 'react';
import { Event as EventIcon } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';

interface PatientLastEncounterIndicatorProps {
  isHovered: boolean;
}

export const PatientLastEncounterIndicator: React.FC<PatientLastEncounterIndicatorProps> = ({
  isHovered,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '16px',
          border: '1.5px solid',
          borderColor: isHovered ? 'borderColors.brand' : 'borderColors.primary',
          bgcolor: isHovered ? 'borderColors.brand' : 'backgroundColors.secondary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease-in-out',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
          '&:hover': {
            bgcolor: 'borderColors.brand',
            borderColor: 'borderColors.brand',
            transform: 'scale(1.1)',
          },
        }}
      >
        <EventIcon
          sx={{
            fontSize: 18,
            color: isHovered ? 'white' : theme.palette.text.secondary,
            transition: 'color 0.2s ease-in-out',
          }}
        />
      </Box>
    </Box>
  );
};

